<script>
import router from "../../index";
import axios from "axios";
import { clearClientSession } from "@/helpers/sessionHelper";

export default {
  created() {
    clearClientSession();

    var config_logout = {
      method: "post",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/logout",
      headers: {
        Accept: "application/json",
      },
    };

    axios(config_logout)
      .then(function (response) {
        console.log("logout response:", response);
      })
      .catch(function (error) {
        console.log("logout error (ignored):", error);
      })
      .finally(function () {
        clearClientSession();
        router.push("/login").catch(() => {});
      });

    router.push("/login").catch(() => {});
  },
};
</script>
